import React from "react"
export const LeftArrowIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="13" viewBox="0 0 10 13" fill="none">
        <path d="M0.00603676 6.54196L9.82422 0.5V12.5L0.00603676 6.54196Z" fill="white" />
      </svg>
    )
  }
  export const RefreshIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M8.8472 11.4042L7.2722 9.72708L11.6472 9.87292L11.2826 14L9.8972 12.5125C8.4097 13.3146 6.6597 13.4896 5.04095 12.9792C2.2847 12.1042 0.476367 9.47917 0.66595 6.59167L2.1097 6.69375C1.96387 8.91042 3.34928 10.9375 5.47845 11.5938C6.5722 11.9437 7.78262 11.8708 8.8472 11.4042ZM8.78887 1.02083C11.5597 1.89583 13.3534 4.52083 13.1639 7.40833L11.7201 7.30625C11.8659 5.08958 10.4805 3.07708 8.35137 2.40625C7.22845 2.05625 6.03262 2.12917 4.96803 2.59583L6.54303 4.27292L2.16803 4.12708L2.53262 0L3.93262 1.4875C4.85137 0.991667 5.8722 0.729167 6.90762 0.729167C7.5347 0.729167 8.17637 0.83125 8.78887 1.02083Z"
          fill="white"
        />
      </svg>
    )
  }
  export const eagleImage = () => {return <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="9.09961" cy="9" r="5.5" stroke="white"/>
  <rect x="0.599609" y="0.5" width="17" height="17" rx="8.5" stroke="white"/>
  </svg>}

export const birdieImage = () => {return <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="8.15039" cy="8" r="7.5" stroke="white"/>
</svg>
}
  export const championsStartHole = () => {return <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.03906 6.17898V6.30398H1.16406H10.7816L7.53238 9.24828C7.18501 9.56305 7.18501 10.079 7.53238 10.3938C7.87264 10.7021 8.41968 10.7021 8.75994 10.3938L13.5285 6.07274C13.8759 5.75797 13.8759 5.24203 13.5285 4.92726L8.75994 0.606241C8.41968 0.29792 7.87264 0.29792 7.53238 0.606241C7.18501 0.921015 7.18501 1.43695 7.53238 1.75172L10.7816 4.69602H1.16406H1.03906V4.82102V6.17898Z" fill="#BDFF69" stroke="#BDFF69" stroke-width="0.25"/>
  </svg>
  }
    export const doublebogeyImage = () => {return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="11" height="11" stroke="white"/>
    <rect x="0.5" y="0.5" width="15" height="15" stroke="white"/>
    </svg>
    }
    export const bogeyImage = () => {return <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.549805" y="0.5" width="15" height="15" stroke="white"/>
    </svg>
    
    }